import { useAuth } from './AuthProvider'

// MC ERP App Roles. NOT all of these are defined in the Entra app registration (verified
// 2026-09-07 against GET /api/entra/app-roles) — 'IT.Viewer', 'HR.*', 'Finance.*', 'School.Manager',
// 'School.Viewer', 'Operations.Viewer' are UI-only names nobody can ever hold; assigning them in
// role-admin fails with "App role 'X' not defined on the service principal." They're kept here
// (hasAnyRole/hasRole elsewhere take plain strings, unconstrained by this type) rather than removed,
// since untangling every reference is a separate decision. The roles Entra actually defines:
// 'IT.Admin', 'CEO', 'Verwaltung.Leitung', 'Operations.Manager', 'Support', the 7 Verwaltung.*/
// Schule.* roles added 2026-09-07, and 'IT.Support' (added 2026-09-07 — create it in the Entra
// portal, App registrations → the app → App roles → + Create app role, Value = IT.Support exactly,
// before assigning anyone; role-admin will 404 "not defined on the service principal" until then).
export type AppRole =
  | 'IT.Admin'
  | 'IT.Support'
  | 'IT.Viewer'
  | 'HR.Manager'
  | 'HR.Viewer'
  | 'Finance.Manager'
  | 'Finance.Viewer'
  | 'School.Manager'
  | 'School.Viewer'
  | 'Operations.Manager'
  | 'Operations.Viewer'
  | 'CEO'
  | 'Verwaltung.Leitung'
  | 'Verwaltung.Buchhaltung'
  | 'Verwaltung.Kasse'
  | 'Verwaltung.Lager'
  | 'Verwaltung.Spueler'
  | 'Schule.Mitarbeiterin'
  | 'Schule.Standortleiterin'
  | 'Schule.Projektleiter'
  | 'Support'
  | 'QM.Kontrolle'
  | 'QM.Leitung'
  | 'authenticated'

export function usePermissions() {
  const { user } = useAuth()

  // SWA built-in auth: userRoles contains 'anonymous', 'authenticated', plus
  // any custom roles configured in Azure SWA role management.
  // We remove the dot-filter to ensure all Entra ID roles are captured.
  const roles = (user?.userRoles ?? []) as string[]

  const hasRole = (role: string) => roles.includes(role)
  
  const hasAnyRole = (...check: string[]) => {
    // If no specific roles are required, any authenticated user has access.
    if (check.length === 0) return true
    return check.some((r) => roles.includes(r))
  }

  const isAdmin = hasRole('IT.Admin')

  return { roles, hasRole, hasAnyRole, isAdmin }
}
